import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import PageSeo from '../components/PageSeo';
import { SEO } from '../utils/seoConfig';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#F5F5F5] py-12">
      <PageSeo {...SEO.termsOfService} />
      <div className="container mx-auto px-4 max-w-4xl">
        <Card>
          <CardContent className="p-8">
            <h1 className="text-4xl font-bold text-[#0A2540] mb-6">
              Conditions Générales d'Utilisation
            </h1>
            
            <p className="text-sm text-gray-500 mb-8">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>

            <div className="space-y-6 text-gray-700">
              {/* Article 1 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  1. Objet
                </h2>
                <p className="mb-3">
                  Les présentes Conditions Générales d'Utilisation (ci-après "CGU") ont pour objet de définir les modalités et conditions d&apos;utilisation de la plateforme GEOTS.consulting (ci-après "la Plateforme"), mise à disposition par GEO TS CONSULTING, SAS au capital social de [à compléter] €, immatriculée au RCS de Paris sous le numéro 993 093 772, dont le siège social est situé 26 Rue des Rigoles, 75020 PARIS.
                </p>
                <p>
                  La Plateforme est un marketplace B2B spécialisé dans le secteur géotechnique, permettant la mise en relation entre fournisseurs d'équipements, services et clients professionnels.
                </p>
              </section>

              {/* Article 2 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  2. Acceptation des CGU
                </h2>
                <p className="mb-3">
                  L'utilisation de la Plateforme implique l'acceptation pleine et entière des présentes CGU. Ces conditions s'appliquent à tous les utilisateurs de la Plateforme, qu&apos;ils soient :
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Visiteurs</strong> : Utilisateurs naviguant sur la Plateforme sans inscription</li>
                  <li><strong>Utilisateurs inscrits</strong> : Professionnels ayant créé un compte</li>
                  <li><strong>Fournisseurs</strong> : Entreprises proposant des produits ou services</li>
                  <li><strong>Clients</strong> : Professionnels recherchant des produits ou services</li>
                </ul>
              </section>

              {/* Article 3 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  3. Inscription et Compte Utilisateur
                </h2>
                
                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  3.1 Création de compte
                </h3>
                <p className="mb-3">
                  Pour accéder à certaines fonctionnalités de la Plateforme, l&apos;utilisateur doit créer un compte en fournissant des informations exactes, complètes et à jour. L'utilisateur s&apos;engage à :
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Fournir des informations véridiques et professionnelles</li>
                  <li>Maintenir ses informations à jour</li>
                  <li>Préserver la confidentialité de ses identifiants</li>
                  <li>Ne pas créer de compte pour une autre personne</li>
                  <li>Être juridiquement en mesure de contracter (majeur, capacité juridique)</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  3.2 Types de comptes
                </h3>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Compte Client</strong> : Recherche et achat de produits/services</li>
                  <li><strong>Compte Fournisseur</strong> : Publication et vente de produits/services</li>
                  <li><strong>Compte Mixte</strong> : Cumul des deux fonctionnalités</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  3.3 Responsabilité du compte
                </h3>
                <p>
                  L'utilisateur est seul responsable de toutes les activités effectuées depuis son compte. En cas d&apos;utilisation non autorisée, l&apos;utilisateur doit immédiatement nous en informer.
                </p>
              </section>

              {/* Article 4 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  4. Services Proposés
                </h2>
                
                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  4.1 Marketplace
                </h3>
                <p className="mb-3">
                  La Plateforme permet aux fournisseurs de présenter leurs produits et services, et aux clients de les découvrir et les acheter. Les services incluent :
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Catalogue de produits géotechniques</li>
                  <li>Système de demandes de devis</li>
                  <li>Réservation de services</li>
                  <li>Système d'avis et évaluations</li>
                  <li>Messagerie entre professionnels</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  4.2 Annuaire Professionnel
                </h3>
                <p className="mb-3">
                  L'annuaire permet aux entreprises du secteur de créer une fiche professionnelle. Deux niveaux sont proposés :
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Gratuit</strong> : Fiche standard dans l'annuaire</li>
                  <li><strong>Premium</strong> : Mise en avant avec badge, priorité d'affichage, statistiques détaillées</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  4.3 Système d'avis
                </h3>
                <p>
                  Les utilisateurs autorisés peuvent soumettre des avis sur les produits. Tous les avis sont soumis à modération avant publication pour garantir leur authenticité et leur conformité.
                </p>
              </section>

              {/* Article 5 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  5. Obligations des Utilisateurs
                </h2>
                
                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  5.1 Obligations générales
                </h3>
                <p className="mb-3">L'utilisateur s&apos;engage à :</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Utiliser la Plateforme de manière professionnelle et loyale</li>
                  <li>Ne pas porter atteinte à l'ordre public ou aux bonnes mœurs</li>
                  <li>Respecter les droits de propriété intellectuelle</li>
                  <li>Ne pas diffuser de contenu illicite, diffamatoire ou discriminatoire</li>
                  <li>Ne pas perturber le fonctionnement de la Plateforme</li>
                  <li>Ne pas collecter de données des autres utilisateurs</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  5.2 Obligations des fournisseurs
                </h3>
                <p className="mb-3">Les fournisseurs s&apos;engagent en plus à :</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Publier des informations exactes sur leurs produits/services</li>
                  <li>Respecter les prix et conditions annoncés</li>
                  <li>Livrer les produits conformes aux descriptions</li>
                  <li>Respecter les délais annoncés</li>
                  <li>Traiter les demandes de devis dans des délais raisonnables</li>
                </ul>
              </section>

              {/* Article 6 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  6. Contenu Utilisateur
                </h2>
                <p className="mb-3">
                  L'utilisateur conserve la propriété du contenu qu&apos;il publie (descriptions, photos, avis). Toutefois, il accorde à GEO TS CONSULTING une licence mondiale, gratuite et non-exclusive d&apos;utilisation, reproduction et représentation de ce contenu aux fins d'exploitation de la Plateforme.
                </p>
                <p className="mb-3">
                  GEO TS CONSULTING se réserve le droit de modérer, modifier ou supprimer tout contenu non conforme aux présentes CGU ou à la législation en vigueur.
                </p>
              </section>

              {/* Article 7 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  7. Modération et Sanctions
                </h2>
                <p className="mb-3">
                  GEO TS CONSULTING se réserve le droit de :
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Modérer tout contenu publié sur la Plateforme</li>
                  <li>Suspendre ou supprimer un compte en cas de manquement aux CGU</li>
                  <li>Refuser l&apos;accès à la Plateforme à tout utilisateur</li>
                  <li>Prendre toute mesure appropriée en cas d&apos;utilisation frauduleuse</li>
                </ul>
              </section>

              {/* Article 8 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  8. Responsabilité
                </h2>
                
                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  8.1 Rôle de GEO TS CONSULTING
                </h3>
                <p className="mb-3">
                  GEO TS CONSULTING agit en tant qu'intermédiaire technique entre fournisseurs et clients. GEO TS CONSULTING n&apos;est pas partie aux transactions effectuées entre utilisateurs et n&apos;est pas responsable de :
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>La qualité, sécurité, légalité des produits/services proposés</li>
                  <li>La capacité des fournisseurs à honorer leurs engagements</li>
                  <li>La capacité des clients à payer</li>
                  <li>Les litiges entre utilisateurs</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  8.2 Limitation de responsabilité
                </h3>
                <p>
                  GEO TS CONSULTING met tout en œuvre pour assurer la disponibilité et la sécurité de la Plateforme, mais ne peut garantir un fonctionnement ininterrompu. GEO TS CONSULTING ne saurait être tenu responsable des dommages indirects.
                </p>
              </section>

              {/* Article 9 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  9. Données Personnelles
                </h2>
                <p>
                  Le traitement des données personnelles est régi par notre{' '}
                  <Link to="/privacy-policy" className="text-[#635BFF] hover:underline font-semibold">
                    Politique de Confidentialité
                  </Link>, conforme au Règlement Général sur la Protection des Données (RGPD).
                </p>
              </section>

              {/* Article 10 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  10. Propriété Intellectuelle
                </h2>
                <p className="mb-3">
                  La Plateforme et tous ses éléments (structure, graphismes, textes, logos, bases de données) sont protégés par le droit d'auteur, le droit des marques et le droit des bases de données.
                </p>
                <p>
                  Toute reproduction, représentation, modification ou exploitation non autorisée est strictement interdite et peut donner lieu à des poursuites.
                </p>
              </section>

              {/* Article 11 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  11. Résiliation
                </h2>
                <p className="mb-3">
                  L'utilisateur peut à tout moment supprimer son compte depuis son espace personnel. GEO TS CONSULTING peut également résilier un compte en cas de violation des CGU, après mise en demeure restée sans effet.
                </p>
              </section>

              {/* Article 12 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  12. Modification des CGU
                </h2>
                <p>
                  GEO TS CONSULTING se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés par email ou notification sur la Plateforme. La poursuite de l&apos;utilisation après modification vaut acceptation des nouvelles conditions.
                </p>
              </section>

              {/* Article 13 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  13. Droit Applicable et Juridiction
                </h2>
                <p className="mb-3">
                  Les présentes CGU sont régies par le droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux de Paris seront seuls compétents.
                </p>
              </section>

              {/* Article 14 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  14. Contact
                </h2>
                <p>
                  Pour toute question concernant les présentes CGU, vous pouvez nous contacter :
                </p>
                <ul className="list-none ml-4 mt-3 space-y-2">
                  <li>📧 Email : contact@geots.consulting</li>
                  <li>📞 Téléphone : +33 1 64 40 95 27</li>
                  <li>📍 Adresse : GEO TS CONSULTING - 26 Rue des Rigoles, 75020 PARIS</li>
                </ul>
              </section>
            </div>

            {/* Retour */}
            <div className="mt-12 pt-6 border-t">
              <Link 
                to="/" 
                className="text-[#635BFF] hover:text-[#5248d9] font-semibold inline-flex items-center"
              >
                ← Retour à l'accueil
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
